export default __webpack_public_path__ + "static/media/bg01.c2e50904.svg";